import styled from 'styled-components';
import { COLORS, SIZING } from '../../styles/variables';
import { device } from '../../styles/devices';

export const ModelContainer = styled.div<{ ist3?: boolean }>`
  flex: 1;
  @media ${device.laptop} {
    flex: 1 1 ${({ ist3 }) => (ist3 ? '429px' : '282px')};
    max-width: ${({ ist3 }) => (ist3 ? '429px' : '282px')};
  }
  @media ${device.laptopL} {
    flex: 1 1 ${({ ist3 }) => (ist3 ? '693px' : '546px')};
    max-width: ${({ ist3 }) => (ist3 ? '693px' : '546px')};
  }
`;

export const ModelPriceLabel = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  margin-bottom: ${SIZING.unit(1)};
  letter-spacing: 0.003px;
  color: ${COLORS.grey60};
  @media ${device.tablet} {
    margin-bottom: 0px;
    font-size: 16px;
  }
  &.msrp {
    margin-top: ${SIZING.unit(1)};
  }
`;

export const ModelPrice = styled.p<{ ist3?: boolean }>`
  letter-spacing: 0.002px;
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
  margin-top: ${SIZING.unit(1)};
  color: ${COLORS.grey80};
  @media ${device.tablet} {
    display: inline;
    margin-top: 0;
    margin-left: ${SIZING.unit(1)};
  }
  @media ${device.laptop} {
    display: ${({ ist3 }) => (ist3 ? 'inline' : 'block')};
    margin-top: ${({ ist3 }) => (ist3 ? '' : SIZING.unit(1))};
    margin-left: ${({ ist3 }) => (ist3 ? '' : '0')};
  }
  @media ${device.laptopL} {
    display: inline;
    margin-left: ${SIZING.unit(1)};
    margin-top: 0;
    font-size: 24px;
    line-height: 36px;
  }
`;

export const ModelMsrpPrice = styled.p<{ ist3?: boolean }>`
  display: inline;
  margin-left: ${SIZING.unit(1)};
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.003px;
  color: ${COLORS.grey80};
  @media ${device.laptop} {
    display: ${({ ist3 }) => (ist3 ? 'inline' : 'block')};
    margin-top: ${({ ist3 }) => (ist3 ? '' : SIZING.unit(1))};
    margin-left: ${({ ist3 }) => (ist3 ? '' : '0')};
  }
  @media ${device.laptopL} {
    display: inline;
    margin-left: ${SIZING.unit(1)};
    margin-top: 0;
  }
`;

export const LegalTextContainer = styled.p`
  color: ${COLORS.grey80};
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.002px;
  font-weight: 400;
  margin-top: ${SIZING.unit(3)};
`;

export const CtaContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-self: flex-start;
  font-family: 'Audi Type';
  padding: 60px 0px;
  @media ${device.tablet} {
    flex-direction: row;
    flex-wrap: wrap;
  }
  @media ${device.laptopM} {
    justify-content: center;
    margin-left: 60px;
  }
`;
export const ContactDealerText = styled.p`
  padding: 24px 0;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  color: ${COLORS.black};
`;
